import React, { useEffect } from 'react'
import Button from '@/components/UiElements/Button'
import DeleteAbsoluteButton from '@/components/UiElements/DeleteAbsoluteButton'
import EngravingSettingForm from './EngravingSettingForm'
import Modal from '@/components/Modal/Modal'


interface SelectTargetObjectProps {
	formData: any,
	onChange: (name: string, value: any) => void;
	updateForm: (itemName: string, attributeName: string, attributeValue: any) => void;
}


const EngravingSetting: React.FC<SelectTargetObjectProps> = ({ formData, onChange }) => {

	const [engravingSetting, setEngravingSetting] = React.useState<any>('')
	const [active, setActive] = React.useState<boolean>(false)



	const handleSetEngravingSetting = async () => {
		setActive(true)


	}

	/*const handleEngravingSettingModal = (form :any) => {
		setEngravingSetting(form)
		onChange('engravingSetting', form)
	}*/

	const handleRemoveEngravingSetting = () => {
		setEngravingSetting('')
		onChange('engravingSetting', null)
	}

	const handleCloseModal = ()=> {
		setActive(false)
	}

	const handleOnUpdateSuccess = (setting:any) => {
		onChange('engravingSetting', setting)
		handleCloseModal()
	}

	useEffect(() => {
		if (formData.engravingSetting !== engravingSetting?.string) {
			setEngravingSetting(formData.engravingSetting || null)
		}
		console.log(formData.engravingSetting, "formData.engravingSetting")
	}, [formData])


	return (
		<>
			<Modal isOpen={active} onClose={() => handleCloseModal()} title={engravingSetting ? "Edit engraving setting" : "Add engraving setting"} closeOnOutsideClick={false}>
				<EngravingSettingForm settings={engravingSetting} onUpdateSuccess={handleOnUpdateSuccess}/>
			</Modal>
			<div className={'flex flex-row gap-xs w-full'}>
				<div className={"flex-row gap-md flex w-full relative"}>
					<div className={"flex flex-1"}>
						<Button onClick={handleSetEngravingSetting} className={`flex-1 inset-1 !justify-start !flex-row gap-md ${active ? '!border-primary-500 !shadow-focus' : ''} `} type={'alt'} disabled={active} icon={`${active ? '' : ''}`} iconClassName={active ? 'animate-spin' : ''}>
							<span>{engravingSetting ? "Edit Engraving Setting" :"Add Engraving Setting"}</span>
						</Button>
					</div>
					{engravingSetting &&
						<DeleteAbsoluteButton
							className={'!relative !top-0 !right-0 !h-[44px] !w-[44px] px-xl col-span-12 !p-0'}
							onClick={handleRemoveEngravingSetting}
						/>
					}
				</div>
			</div>

		</>
	)
}

export default EngravingSetting
